





















































import { Component, Mixins, Prop, Provide, Vue, Emit } from 'vue-property-decorator'
import { URLS } from '../../../../../service/constant'
import { ConstantMixin } from '../ConstantMixin'
import { OperationMixin } from '../OperationMixin'
import { myBrowser } from '../../../../../service/common'

@Component
export default class Notification extends Mixins(ConstantMixin, OperationMixin) {
  @Prop() public index!: number
  private uploadUrl = URLS.UPLOAD_URL
  private uploadData = {
    upload_type: 'attachment'
  }

  private uploadFilename: any[] = []
  private fileList: any[] = []
  private using: boolean = false

  @Emit()
  onUsing(val) {
    return val
  }

  public handleChange(info) {
    if (info.file.status === 'done') {
      // this.using = false
      // this.onUsing(this.using)
      if (info.file.response.success) {
        let { url, title } = info.file.response.data
        this.uploadFilename = [...this.uploadFilename, title]
        this.sendMessageData.img = [...this.sendMessageData.img, url]
      } else {
        this.$message.error(info.file.response.error)
      }
    } else if (info.file.status === 'uploading') {
      // this.using = true
      // this.onUsing(this.using)
    } else if (info.file.status === 'error') {
      // this.using = false
      // this.onUsing(this.using)
    }
  }

  public remove(index) {
    this.uploadFilename.splice(index, 1)
    this.sendMessageData.img.splice(index, 1)
    // this.sendMessageData.detail = ''
  }
  // 监听粘贴事件
  public pasteFile(e: any) {
    // 参数定义
    let imgs = ['gif', 'png', 'jpeg', 'bmp', 'webp', 'jpg', 'x-icon', 'vnd.microsoft.icon']
    let self = this
    let items = (e.clipboardData || (window as any).clipboardData).items || []
    let file: any = null
    let name = ''
    let type = ''
    let ed = ''
    let mb = myBrowser()

    for (let item of items) {
      if (item.kind === 'file' && item.type.indexOf('image') !== -1) {
        file = item.getAsFile()
      } else if (item.kind === 'string') {
        item.getAsString((str) => {
          name = str.split('.')[0]
          ed = str.split('.')[1]
          type = imgs.includes(ed) ? ed : 'png'
        })
      }
    }
    if (mb === 'Safari') {
      // 获取完名字之后上传
      if (file) {
        this.uploadFile(file)
      } else {
        this.$message.error('缺少上传内容！')
      }
    }

    if (mb === 'Chrome') {
      // 获取完名字之后上传
      if (file) {
        console.log(file)
        setTimeout(() => {
          console.log(name)
          console.log(type)
          if (name && type) {
            const f = new File([file], `${name}.${type}`)
            self.uploadFile(f)
          } else {
            self.uploadFile(file)
          }
        }, 0)
      } else {
        this.$message.error('缺少上传内容！')
      }
    }
  }
  // 监听鼠标进入事件
  public onmouseenter(ref) {
    let target: any = this.$refs[ref]
    target.focus()
  }
  // 监听鼠标离开事件
  public onmouseleave(ref) {
    let target: any = this.$refs[ref]
    target.blur()
  }
  // 上传方法
  public uploadFile(file) {
    let self = this
    let formData = new FormData()
    // this.using = true
    // this.onUsing(this.using)
    formData.append('file', file)
    formData.append('upload_type', self.uploadData.upload_type)
    let xhr = new XMLHttpRequest()
    xhr.onload = function() {
      try {
        let result = JSON.parse(this.responseText)
        console.log(result)
        if (result.success) {
          // self.using = false
          // self.onUsing(self.using)
          let { url, title } = result.data
          self.uploadFilename = [...self.uploadFilename, title]
          self.sendMessageData.img = [...self.sendMessageData.img, url]
        } else {
          self.$message.error(result.error)
          // self.using = false
          // self.onUsing(self.using)
        }
      } catch (e) {
        console.log(e)
        // self.using = false
        // self.onUsing(self.using)
      }
    }

    xhr.open('POST', URLS.UPLOAD_URL, true)
    xhr.send(formData)
  }
}
